export const BORDERS = {
	border100: 'rgba(227, 226, 226, 0.1)',
	border200: 'rgba(227, 226, 226, 0.15)'
} as const;
